import { Link, useLocation } from 'react-router-dom';
import { Search, Menu, Bell, ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ThemeToggle } from './ThemeToggle';
import { LanguageSwitcher } from './LanguageSwitcher';
import { navigation } from './Sidebar';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

interface TopNavProps {
  user?: any;
  onSearchClick: () => void;
  onMenuClick?: () => void;
}

export function TopNav({ user, onSearchClick, onMenuClick }: TopNavProps) {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const normalized = pathname === '/dashboard' ? '/' : pathname;
  const section = navigation.find((s) => s.items.some((i) => i.path === normalized));
  const item = section?.items.find((i) => i.path === normalized);

  const roleLabel = user?.role === 'SUPER_ADMIN' ? 'Platform workspace' : user?.role?.replace('_', ' ');

  return (
    <header className="app-topbar od-row">
      <Button
        variant="ghost"
        size="icon"
        className="mobile-menu lg:hidden"
        onClick={onMenuClick}
        aria-label="Open navigation"
      >
        <Menu className="od-icon" />
      </Button>

      <div className="route-breadcrumb od-row od-fill">
        {section && (
          <>
            <span className="breadcrumb-group">{t(section.titleKey)}</span>
            <ChevronRight className="od-icon breadcrumb-group" />
          </>
        )}
        <strong>{item ? t(item.nameKey) : ''}</strong>
      </div>

      <Button variant="outline" className="global-search" onClick={onSearchClick} aria-label={t('topNav.searchPages')}>
        <Search className="od-icon" />
        <span>{t('topNav.searchPages')}</span>
        <kbd>⌘ K</kbd>
      </Button>

      {user?.role && (
        <span className="topbar-role">
          <Badge
            variant="outline"
            className="border-emerald-500/20 bg-emerald-500/10 text-emerald-700 dark:text-emerald-300"
          >
            {roleLabel}
          </Badge>
        </span>
      )}

      <div className="topbar-tools od-row">
        <Button variant="ghost" size="icon" asChild>
          <Link to="/notifications" aria-label="Notifications">
            <Bell className="od-icon" />
          </Link>
        </Button>
        <LanguageSwitcher />
        <ThemeToggle />
      </div>
    </header>
  );
}
